<p>info-test-page works! --{{ test }}-- --{{ loggedInUser }}--</p>
